import React, { Component } from 'react';

import company from '../images/company.svg';
import world from '../images/world.svg';
import znak from '../images/znak.svg';
import Isvg from 'react-inlinesvg';
import image from '../images/image.png';
import {
    Col,
    Row,
    Container,
    Button,
} from 'reactstrap';


export default class HowWeWork extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let home = this.props.home;
        return (
            <>
                <div className="HowWeWork">
                    <div className="content">
                        <Container>
                            <Row>
                                <Col xl="4" lg="4" md="12">
                                    <img src={image} className="img-fluid image" />
                                </Col>
                                <Col xl="8" lg="8" md="12">
                                    <h1 dangerouslySetInnerHTML={{ __html: home.section3 && home.section3.title && home.section3.title[this.props.lang] }}></h1>

                                    <div dangerouslySetInnerHTML={{ __html: home.section3 && home.section3.content && home.section3.content[this.props.lang] }}></div>

                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <div className="companyinfo">
                        <Container>
                            <Row>
                                <Col xl="4" lg="4" xs="4">
                                    <Isvg src={company} />
                                    <div className="info">
                                        <h2>{home.section3 && home.section3.year}</h2>
                                        <p>{this.props.translate("KOMPANIJA OSNOVANA")}</p>
                                    </div>
                                </Col>
                                <Col xl="4" lg="4" xs="4">
                                    <Isvg src={world} />
                                    <div className="info">
                                    <h2>{home.section3 && home.section3.countries}</h2>
                                        <p>{this.props.translate("ZEMALJA POSLUJEMO")}</p>
                                    </div>
                                </Col>
                                <Col xl="4" lg="4" xs="4">
                                    <Isvg src={znak} />
                                    <div className="info">
                                    <h2>{home.section3 && home.section3.projects}</h2>
                                        <p>{this.props.translate("ZNAKOVA POSTAVLJENO")}</p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                </div>
            </>
        );
    }
}